import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Error = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="262" viewBox="0 0 257 262" width="257" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        d="M87.5 153.28 166.61 0l-20.46 165.27 110.62 20.1s-96.12 25.21-95.32 27.3 14.42 48.44 14.42 48.44l-70.1-37.45-78.59 11.25 39.35-41.43-49.81-55.15 70.77 14.94z"
        fill={shades.secondary.medium}
      />
      <path
        className={strokeStyle}
        d="m181.28 90.57 1.83 34.63c.18 2.54 2.61 4.52 5.56 4.52 3.08 0 5.57-2.15 5.57-4.81l1.23-34.63c0-2.66-2.49-4.81-5.57-4.81h-3.06c-3.21 0-5.75 2.34-5.56 5.1Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m195.18 145-.27-2.99c-.25-2.76-2.91-4.88-6.11-4.88-2.74 0-5.15 1.57-5.9 3.85l-.98 2.99c-1.11 3.36 1.8 6.71 5.85 6.74h1.25c3.59.03 6.43-2.6 6.15-5.69z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m185.67 84.65 1.83 34.63c.18 2.54 2.61 4.52 5.56 4.52 3.08 0 5.57-2.15 5.57-4.81l1.23-34.63c0-2.66-2.49-4.81-5.57-4.81h-3.06c-3.21 0-5.75 2.34-5.56 5.1Z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m199.56 139.09-.27-2.99c-.25-2.76-2.91-4.88-6.11-4.88-2.74 0-5.15 1.57-5.9 3.85l-.98 2.99c-1.11 3.36 1.8 6.71 5.85 6.74h1.25c3.59.03 6.43-2.6 6.15-5.69z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M208.68 102.85c-2.62-.48-4.13-2.85-3.22-5.02l2.38-5.63.16-.37c2.11-4.99 8.06-7.96 14.12-7.03l3.71.56c8.27 1.26 13.91 7.95 12.74 15.14l-.55 3.36c-.55 3.36-2.84 6.32-6.24 8.03l-8.63 4.35a3.7 3.7 0 0 0-2.18 3.37l.19 7.27c.06 2.29-2.22 4.1-4.86 3.86-2.34-.22-4.07-1.99-3.92-4.01l.79-10.66c.26-3.49 2.71-6.58 6.39-8.04l3.01-1.2a7.4 7.4 0 0 0 4.68-5.22l.23-1.11c.8-3.77-2.3-7.34-6.72-7.74-2.01-.18-3.9.84-4.59 2.48l-2.21 5.24c-.75 1.78-2.91 2.81-5.06 2.41z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m211.48 141.15-.46 2.8c-.43 2.63 1.89 5 4.97 5.05h.71c3.03.07 5.45-2.15 5.21-4.75l-.25-2.81c-.21-2.31-2.43-4.08-5.11-4.08-2.55 0-4.71 1.62-5.07 3.8z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M214.19 99.91c-2.62-.48-4.13-2.85-3.22-5.02l2.38-5.63.16-.37c2.11-4.99 8.06-7.96 14.12-7.03l3.71.56c8.27 1.26 13.91 7.95 12.74 15.14l-.55 3.36c-.55 3.36-2.84 6.32-6.24 8.03l-8.63 4.35a3.7 3.7 0 0 0-2.18 3.37l.19 7.27c.06 2.29-2.22 4.1-4.86 3.86-2.34-.22-4.07-1.99-3.92-4.01l.79-10.66c.26-3.49 2.71-6.58 6.39-8.04l3.01-1.2a7.4 7.4 0 0 0 4.68-5.22l.23-1.11c.8-3.77-2.3-7.34-6.72-7.74-2.01-.18-3.9.84-4.59 2.48l-2.21 5.24c-.75 1.78-2.91 2.81-5.06 2.41z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m216.99 138.22-.46 2.8c-.43 2.63 1.89 5 4.97 5.05h.71c3.03.07 5.45-2.15 5.21-4.75l-.25-2.81c-.21-2.31-2.43-4.08-5.11-4.08-2.55 0-4.71 1.62-5.07 3.8z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M123.62 119.58a12.5 12.5 0 0 1-15.17 12.2 12.3 12.3 0 0 1-7.51-5c10.22.59 17.85-2.92 21.09-13.3a12.3 12.3 0 0 1 1.59 6.1Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M119.62 136.74a36 36 0 0 1-11.18.9q.06-2.86.02-5.86 1.3.3 2.69.29c2.75 0 5.26-.88 7.32-2.37q.78 3.47 1.16 7.04z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M118.46 160.73c-6.28 2.59-10.94 2.49-13.49-.96 2.35-6.06 3.28-13.67 3.47-22.13 3.71.24 7.43.04 11.18-.9.84 7.71.29 15.65-1.16 23.99Z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M122.03 113.48c-3.24 10.38-10.87 13.89-21.09 13.3a12.48 12.48 0 1 1 21.09-13.3Z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M169.99 167.69c0 3.49-2.12 6.81-5.93 9.75a40 40 0 0 1-9.26 5.2c-10.75 4.51-26.3 7.36-43.62 7.36q-1.41 0-2.8-.03-.8 0-1.58-.03l-.49-.01a145 145 0 0 1-6.53-.35l-.27-.02-1.63-.14-.81-.07q-1.96-.19-3.88-.42l-1.16-.15-1.49-.2-1.68-.25-1.57-.25a121 121 0 0 1-7.19-1.45l-.99-.24-1.82-.47-1.54-.42a68 68 0 0 1-11.67-4.45 35 35 0 0 1-3.55-2.02l-.51-.33q-.92-.62-1.73-1.25c-3.81-2.94-5.93-6.25-5.93-9.75 0-9.75 16.44-18.03 39.37-21.07 6.08-.82 12.63-1.25 19.44-1.25 32.48 0 58.81 9.98 58.81 22.32z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M93.2 188.93" fill={shades.secondary.light} strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M75.77 185.49" fill={shades.black} strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="m77.31 185.91-.84 19.3c-14.62-4.06-24.09-10.62-24.09-18.01v-19.51c0 3.49 2.12 6.81 5.93 9.75q.81.63 1.73 1.25l.51.33a36 36 0 0 0 3.55 2.02l.56.28a68 68 0 0 0 11.11 4.17z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M157.24 201.08c-10.77 5.16-27.4 8.45-46.06 8.45-12.98 0-24.99-1.59-34.72-4.29v-.02l.84-19.3a80 80 0 0 0 3.82.94q2.98.68 6.18 1.22l1.57.25q.82.14 1.68.25l1.49.2 1.16.15q1.92.22 3.88.42l.81.07 1.63.14.27.02q1.06.09 2.13.15 1.13.07 2.28.12a145 145 0 0 0 6.99.15c17.32 0 32.88-2.84 43.62-7.36-5.32 9.22-2.49 16.44 2.44 18.44z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M169.99 167.69v19.51c0 5.24-4.77 10.06-12.75 13.87-4.93-2-7.75-9.22-2.44-18.44a40 40 0 0 0 9.26-5.2c3.81-2.94 5.93-6.25 5.93-9.75z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m154.88 182.5-.08.14" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M128.68 75.19h-.02a108 108 0 0 0-17.47-1.33c-3.81 0-7.47.18-10.89.49-13.28 1.24-22.83 4.65-22.83 8.66s9.77 7.49 23.28 8.67q4.95.44 10.43.45c7.49 0 14.43-.67 20.03-1.77 8.32-1.67 13.71-4.33 13.71-7.35 0-3.32-6.51-6.22-16.24-7.81zm3.43 9.51c-4.5 1.19-12.19 1.96-20.93 1.96-5.12 0-9.89-.28-13.85-.73-6.77-.76-11.24-2.1-11.24-3.61s4.71-2.88 11.79-3.64c3.85-.44 8.42-.67 13.3-.67 8.24 0 15.54.68 20.11 1.75 3.14.71 4.98 1.6 4.98 2.56 0 .89-1.53 1.71-4.15 2.38z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m157.04 163.36-10.77-71.4-1.35-8.96c0 3.02-5.4 5.68-13.71 7.35a107 107 0 0 1-20.03 1.77 119 119 0 0 1-10.43-.45C87.24 90.49 77.47 87.06 77.47 83l-12.12 80.36-.02.1-.18 1.14c0 3.89 5.16 7.38 13.47 9.93 8.33 2.55 19.85 4.12 32.56 4.12 25.44 0 46.06-6.29 46.06-14.05zm-77.34 3.59a30 30 0 0 1-8.4-4.94l.8-4.82 10.42-62.55c21.67 4.26 41.27 4.38 57.33-2.51l.61 3.49 10.73 62.04.74 4.36c-12.59 9.2-51.06 13.55-72.24 4.94z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M151.2 157.65c-7.93-4.24-22.88-7.1-40.02-7.1-11.26 0-21.58 1.23-29.58 3.29a49 49 0 0 0-9.5 3.33l10.42-62.55c21.67 4.26 41.27 4.38 57.33-2.51l.61 3.49 10.73 62.04z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M136.27 82.32c0 .89-1.53 1.71-4.15 2.38-4.5 1.19-12.19 1.96-20.93 1.96-5.12 0-9.89-.28-13.85-.73-6.77-.76-11.24-2.1-11.24-3.61s4.71-2.88 11.79-3.64c3.85-.44 8.42-.67 13.3-.67 8.24 0 15.54.68 20.11 1.75 3.14.71 4.98 1.6 4.98 2.56z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M151.94 162c-12.59 9.2-51.06 13.55-72.24 4.94a30 30 0 0 1-8.4-4.94l.8-4.82a48 48 0 0 1 9.5-3.33c8-2.06 18.32-3.29 29.58-3.29 17.14 0 32.09 2.86 40.02 7.1l.74 4.36z"
        fill={shades.primary.light}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="m157.24 164.59-.2-1.24q.2.61.2 1.24Z" fill={shades.primary.dark} strokeWidth={strokeWidth} />
      <path d="M136.27 115.13v10.94" stroke="white" strokeWidth={strokeWidth} />
      <path d="M132.4 120.6h7.75" stroke="white" strokeWidth={strokeWidth} />
      <path d="M93.44 137.73v5.62" stroke="white" strokeWidth={strokeWidth} />
      <path d="M97.97 140.54H88.9" stroke="white" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M10.02 181.32H.75" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M5.38 186.38v-10.12" strokeWidth={strokeWidth} />
      <path
        className={strokeStyle}
        d="M120.01 141.37c-3.22.94-7.28 1.18-11.96.92q.05-.3.04-.59c.33-4.73.41-9.57.37-13.93q1.3.3 2.69.29c2.75 0 5.26-.88 7.32-2.37a73 73 0 0 1 1.55 15.67z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M120.01 141.37c.04 6.61-.53 13.48-1.55 19.36-6.28 2.59-10.94 2.49-13.49-.96 1.67-4.3 2.61-10.73 3.08-17.48 4.69.26 8.75.02 11.96-.92Z"
        fill={shades.primary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m127.19 134.5-16.71-8.43-3.39 3.84-5.77 6.55 1.9-9.53.63-3.14s-2.57.18-5.47.41c-3.49.27-7.51.59-8.28.75-1.41.27 12.63-9.34 12.63-9.34l1.96-14.24 3.43 6.16 2.35 4.22 1.96-.67 11.91-3.98-2.2 4.84-3.45 7.63 8.49 14.93z"
        fill={shades.secondary.dark}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m103.85 123.79-.63 3.14c-2.71.2-6.45.52-8.25.67a2.8 2.8 0 0 1-1.91-.53l-2.96-2.13c.77-.16 4.79-.47 8.28-.75 2.9-.24 5.47-.41 5.47-.41z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m112.44 111.08-1.96.67-2.35-4.22-3.43-6.16 2.96 2.13a5 5 0 0 1 1.51 1.7l3.28 5.89z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="m128.54 136.03-14.16-7.16-7.82 8.87a2.25 2.25 0 0 1-3 .34l-2.25-1.62 5.77-6.55 3.39-3.84 16.71 8.43-8.49-14.93 3.45-7.63 2.2-4.84 2.33 1.67c.92.66 1.24 1.87.78 2.9l-4.85 10.71 7.07 12.46a.86.86 0 0 1-1.13 1.19Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path className={strokeStyle} d="M42.58 76.12v4.01" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M34.96 69.68h-3.59" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M42.26 63.2v-4.01" strokeWidth={strokeWidth} />
      <path className={strokeStyle} d="M49.88 69.63h3.59" strokeWidth={strokeWidth} />
    </svg>
  );
};
